import { Button } from '@qred/components-library';
import React from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '~/hooks/useAppDispatch';
import { getHomePageByMarket } from '~/constants/markets';
import { StepStatus } from '~/enums';

import useTranslate from '~/hooks/useTranslate';
import { RootState } from '~/store';
import { pushToGtmLoanAction } from '~/store/actions/gtmActions';

export const ApplicationOverviewFooter = () => {
  const t = useTranslate();
  const dispatch = useAppDispatch();
  const { language, market } = useSelector((state: RootState) => state.intl);

  const onClick = () => {
    dispatch(
      pushToGtmLoanAction({
        actionName: 'close_button_pressed',
      })
    );
    dispatch(pushToGtmLoanAction({ stepStatus: StepStatus.Finished }));
    window.location.assign(getHomePageByMarket(market, language));
  };

  return (
    <Button variant="tertiary" onClick={onClick}>
      {t('Close')}
    </Button>
  );
};
